import React from "react";

import type { BreakpointBackgroundIconId } from "@intelligems/ig-types";

import { useSvgColor } from "../../util";
import { IconProps } from "../types";

import { Path } from "./Path";

const Star = ({ className, color }: IconProps) => {
  const svgColor = useSvgColor(color);
  return (
    <svg className={className} viewBox="0 0 28 28">
      {svgColor.defs && (
        <defs dangerouslySetInnerHTML={{ __html: svgColor.defs }} />
      )}
      <Path
        color={color}
        d="M28,14.02l-2.4-3.13.54-3.88-3.66-1.45-1.45-3.66-3.88.54-3.15-2.43-3.12,2.4-3.88-.54-1.45,3.66-3.66,1.45.54,3.88-2.43,3.16,2.4,3.13-.54,3.88,3.66,1.45,1.45,3.66,3.88-.54,3.12,2.4,3.12-2.4,3.88.54,1.45-3.66,3.66-1.48-.54-3.88,2.46-3.09s0,0,0,0Z"
      />
    </svg>
  );
};

const Circle = ({ className, color }: IconProps) => {
  const svgColor = useSvgColor(color);
  return (
    <svg className={className} viewBox="0 0 28 28">
      {svgColor.defs && (
        <defs dangerouslySetInnerHTML={{ __html: svgColor.defs }} />
      )}
      <circle style={{ fill: color }} cx="14" cy="14" r="14" />
    </svg>
  );
};

export const BackgroundIcon = ({
  id,
  ...props
}: IconProps & { id: BreakpointBackgroundIconId }) => {
  switch (id) {
    case "star":
      return <Star {...props} />;
    case "circle":
      return <Circle {...props} />;
  }
};
